import DOMPurify from 'dompurify'

let svgContainer

/**
 * Directiva v-safe-html: basada en la implementación de v-html de Vue.js
 * Replica el comportamiento de Vue pero con sanitización de DOMPurify.
 * 
 * Basado en: node_modules/vue/src/platforms/web/runtime/modules/dom-props.js
 * Licencia: MIT (Vue.js)
 */
function updateSafeHtml (el, value) {
  const sanitized = DOMPurify.sanitize(value)
  
  // Evitamos leaks de memoria en Chrome ≤55
  if (el.childNodes.length === 1) {
    el.removeChild(el.childNodes[0])
  }

  // IE no soporta innerHTML directamente en SVG elements
  if (el.tagName && isSVG(el.tagName) && !el.innerHTML) {
    svgContainer = svgContainer || document.createElement('div')
    svgContainer.innerHTML = `<svg>${sanitized}</svg>`
    const svg = svgContainer.firstChild
    while (el.firstChild) {
      el.removeChild(el.firstChild)
    }
    while (svg.firstChild) {
      el.appendChild(svg.firstChild)
    }
  } else {
    el.innerHTML = sanitized
  }
}

function isSVG (tagName) {
  return typeof SVGElement !== 'undefined' && tagName instanceof SVGElement
}

export default {
  bind (el, binding) {
    updateSafeHtml(el, binding.value)
  },

  update (el, binding) {
    if (binding.value === binding.oldValue) return
    
    updateSafeHtml(el, binding.value)
  }
}
